import React from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Banner from '../Layout/Banner/Banner';
import Footer from '../Layout/Footer/Footer';

import Categories from '../Products/Categories/Categories';
import Lamparas from '../Products/Lamparas/Lamparas';

import ExteriorBanner from '../Exterior/Banner';
function Home() {
  return (
    <>
      <Navbar />
      <Banner />
      <Categories />
      <ExteriorBanner />
      <Lamparas />
      <Footer />
    </>
  );
}
export default Home;
